import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import userReducer from "../features/user/userSlice"
import adminPagesReducer from "../features/admin/adminPagesSlice"
import formsReducer from "../components/Form/formsSlice"
import locationsReducer from "../features/locations/locationsSlice"
import dataDisplayerReducer from "../components/DataDisplayer/dataDisplyerSlice"
import notificationsReducer from "../features/notifications/notificationsSlice"
import warehousesReducer from "../features/warehouses/warehousesSlice"
import sectionsReducer from "../features/sections/sectionsSlice"
import categoriesReducer from "../features/categories/categoriesSlice"
import itemsReducer from "../features/items/itemsSlice"
import transactionsReducer from "../features/transactions/transactionsSlice"
import issuesReducer from "../features/issues/issuesSlice"
import routerReducer from "../features/router/routerSlice"
import brandsReducer from "../features/brands/brandsSlice"
import projectReducer from "../features/projects/projectsSlice"
import itemsRequestsReducer from "../features/items_requests/itemsRequestsSlice"
import updatesReducer from "../features/updates/updatesSlice"
import userGroupsReducer from "../features/user_groups/userGroupsSlice"
import printersReducer from "../features/printing/printersSlice"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    adminPages: adminPagesReducer,
    forms: formsReducer,
    locations: locationsReducer,
    dataDisplayer: dataDisplayerReducer,
    notifications: notificationsReducer,
    warehouses: warehousesReducer,
    sections: sectionsReducer,
    categories: categoriesReducer,
    items: itemsReducer,
    transactions: transactionsReducer,
    issues: issuesReducer,
    router: routerReducer,
    brands: brandsReducer,
    projects: projectReducer,
    itemsRequests: itemsRequestsReducer,
    updates: updatesReducer,
    userGroups: userGroupsReducer,
    printers: printersReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;